import Box from "@mui/material/Box";
import { Autocomplete, Grid, TextField, Typography } from "@mui/material";
import AppButton from "../../common/AppButton";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { addMedicineInitialValues } from "../../forms/initialValues";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { useEffect, useState } from "react";
import { editMedicine } from "../../../features/medicine/medicineSlice";
import { getCategoryData } from "../../../features/category/categorySlice";
import { getManufacturerData } from "../../../features/manufacturer/manufacturerSlice";
import { getMedicineFormulaData } from "../../../features/medicineFormula/medicineFormulaSlice";
import { Dropdown } from "../batch/dropdown";
import { PharmacySuperCategory, units } from "../../../utils/constants";
const BarcodeReader = require("react-barcode-reader").default;

interface IProps {
  handleClose: () => void;
  setOpenSnackbar: () => void;
  getMedicine: () => void;
  medicine?: any;
  setOpenErrorToast?: any;
  setErrorMessage?: any;
}

const EditMedicineModal = ({
  medicine,
  handleClose,
  getMedicine,
  setOpenSnackbar,
  setOpenErrorToast,
  setErrorMessage,
}: IProps) => {
  const dispatch: any = useAppDispatch();
  const [categoryId, setCategoryId] = useState<any>(null);
  const [categoryIdtest, setCategorytest] = useState<any>(null);
  const [manufacturerId, setManufacturerId] = useState<any>(null);
  const [FormulaId, setFormulaId] = useState<any>(null);
  const [medicineName, setMedicineName] = useState<any>("");
  const [genericName, setGenericName] = useState<any>("");
  const [medicineFormulaName, setMedicineFormulaName] = useState<any>("");
  const [categoryName, setCategoryName] = useState<any>("");
  const [medicineFormulaData, setMedicineFormulaData] = useState<any>(null);
  const [categoryData, setCategoryData] = useState<any>(null);
  const [manufacturerNameData, setManufacturerNameData] = useState<any>(null);
  const [doseDigits, setDoseDigits] = useState<any>("");
  const [doseWord, setDoseWord] = useState<any>("");
  const [test, setTest] = useState<any>(addMedicineInitialValues);
  const [manufacturerName, setManufacturerName] = useState<any>("");
  const [isOpen, setIsOpen] = useState<any>(false);
  const [doseError, setDoseError] = useState<any>("");
  const [medBarcode, setMedBarcode] = useState("");

  const handleScan = (data: any) => {
    // if (data) {
    //   setMedBarcode(data);
    // }
  };

  const handleError = (err: any) => {
    console.error(err);
  };

  const handleChangeEdit = (event: any) => {
    setMedicineFormulaName(event.target.value);
    setIsOpen(true);
  };

  const filtered_list =
    medicineFormulaName != null
      ? medicineFormulaData?.payload?.drug_formula
        ?.filter(function (item: any) {
          return item?.name
            ?.toLowerCase()
            ?.startsWith(medicineFormulaName?.toLowerCase());
        })
        ?.filter(
          (item: any, index: number, self: any[]) =>
            index ===
            self?.findIndex(
              (t) =>
                t?.name?.trim()?.toLowerCase() ===
                item?.name?.trim()?.toLowerCase()
            )
        )
      : medicineFormulaData;

  useEffect(() => {
    if (medicine !== null && medicine !== undefined) {
      const doseParts = (medicine?.dose || "")?.match(/([\d.]+)\s*(\D+)/);
      const digits = doseParts ? doseParts[1] : null;
      const word = doseParts ? doseParts[2]?.trim() : null;
      setMedicineName(medicine?.medicine_name);
      setMedBarcode(medicine?.barcode);
      setFormulaId(medicine?.drug_formula_id);
      setCategoryId(medicine?.category_id);
      setCategorytest(medicine?.category_id);
      setMedicineFormulaName(medicine?.drug_formula_name);
      setCategoryName(medicine?.category_name);
      setDoseDigits(digits);
      setDoseWord(word);
      setGenericName(medicine?.generic_name);
      setManufacturerName(medicine?.manufacturer_name);
    }
  }, [medicine]);

  const handleTextFieldChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = event?.target?.value;
    if (Number(value) < 0 || value === "-0") {
      setDoseError("Dose cannot be negative");
      return; // Do not update the state if the value is invalid
    }

    // Clear the error if the value is valid
    setDoseError("");
    setDoseDigits(value); // Update doseDigits immediately
  };

  const handleSelectChange = (event: any, value: string | null) => {
    const selectedValue = value || ""; // Use an empty string if no value is selected
    setDoseWord(selectedValue); // Update doseWord immediately
  };

  const fetchMedicineFormulaData = async () => {
    try {
      const data: any = await dispatch(getMedicineFormulaData());
      setMedicineFormulaData(data);
    } catch (error) {
      console.error("Error fetching supplier data:", error);
    }
  };
  useEffect(() => {
    fetchMedicineFormulaData();
  }, []);

  const fetchCategoryData = async () => {
    try {
      const data: any = await dispatch(getCategoryData());

      // Ensure payload is an array before filtering
      const categoryArray = Array?.isArray(data?.payload?.category) ? data?.payload?.category : [];

      const super_category = categoryArray?.filter(
        (item: any) => item?.super_category === PharmacySuperCategory.MEDICAL
      );
      setCategoryData(super_category);
    } catch (error) {
      console.error("Error fetching supplier data:", error);
    }
  };

  useEffect(() => {
    fetchCategoryData();
  }, []);

  const fetchManufacturerNameData = async () => {
    try {
      const data: any = await dispatch(getManufacturerData()); // Assuming getSupplierData is async
      setManufacturerNameData(data); // Assuming getSupplierData returns the fetched data
    } catch (error) {
      console.error("Error fetching supplier data:", error);
    }
  };
  useEffect(() => {
    fetchManufacturerNameData();
  }, []);

  const pharmacyId = localStorage?.getItem("pharmacyId");

  const handleInputChange1 = (e: React.ChangeEvent<HTMLInputElement>) => {
    setMedicineName(e.target.value);
  };
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setGenericName(e.target.value);
  };
  const handleInputChange2 = (e: React.ChangeEvent<HTMLInputElement>) => {
    setMedicineName(e.target.value);
  };

  const handleSubmit = async (values: any) => {
    const pharmacyId = localStorage?.getItem("pharmacyId");
    const combinedDoseString = `${doseDigits !== undefined && doseDigits !== "" && doseDigits !== null && doseDigits !== "null" ? doseDigits : ""} ${doseWord !== undefined && doseWord !== "" && doseWord !== null && doseWord !== "null" ? doseWord : ""}`;
    const medicines: any = {
      pharmacy_id: pharmacyId,
      barcode: medBarcode,
      category_id: categoryId ? categoryId : categoryIdtest,
      drug_formula_id: FormulaId,
      //selectedMed,
      manufacturer_id: manufacturerId,
      medicine_id: medicine?.medicine_id,
      name: medicineName,
      dose: combinedDoseString,
      generic_name: genericName,
      super_category: PharmacySuperCategory.MEDICAL,
    };

    !medBarcode && delete medicines?.barcode;

    try {
      const res = await dispatch(editMedicine(medicines));
      if (res.payload.success === true) {
        getMedicine();
        setOpenSnackbar();
        handleClose();
        // window.alert("Medicine updated successfully!");
      } else {
        setOpenErrorToast();
        setErrorMessage(res?.payload);
        // window.alert("Failed to update medicine. Please try again.");
      }
    } catch (error) {
      console.error("Error update medicine: ", error);
    }
  };
  useEffect(() => {
    const select_formula_id = medicineFormulaData?.payload?.drug_formula?.find(
      (medicineFormula: any) =>
        medicineFormula?.name === medicine?.drug_formula_name &&
        medicineFormula?.id
    );
    setFormulaId(select_formula_id?.id);

    const select_category_id = categoryData?.payload?.category?.find(
      (category: any) =>
        category?.name === medicine?.category_name && category?.id
    );
    setCategoryId(select_category_id?.id);

    const select_manufacturer_id = manufacturerNameData?.payload?.manufacturer?.find(
      (manufacturer: any) =>
        manufacturer?.name === medicine?.manufacturer_name && manufacturer?.id
    );
    setManufacturerId(select_manufacturer_id?.id);
  }, [medicineFormulaData, categoryData, manufacturerNameData]);

  const filterOptions = (options: string[], { inputValue }: any) => {
    const normalizedInput = inputValue.toLowerCase();
    return options
      .filter((option) => option.toLowerCase().includes(normalizedInput))
      .sort((a, b) => {
        const aStartsWith = a.toLowerCase().startsWith(normalizedInput);
        const bStartsWith = b.toLowerCase().startsWith(normalizedInput);

        // Push items starting with input to the top
        if (aStartsWith && !bStartsWith) return -1;
        if (!aStartsWith && bStartsWith) return 1;

        // Otherwise, keep the default order
        return a.localeCompare(b);
      });
  };

  return (
    <>
      <BarcodeReader onError={handleError} onScan={handleScan} />

      <Formik
        initialValues={test}
        //validationSchema={addMedicineValidationSchema}
        onSubmit={() => { }}
      >
        <Form>
          <Box sx={{ mt: 0.5 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4}>
                <Typography variant="h6" gutterBottom>
                  Bar Code
                </Typography>
                <Field
                  as={TextField}
                  fullWidth
                  variant="outlined"
                  placeholder="Enter barcode."
                  value={medBarcode}
                  // onChange={(e: any) => setMedBarcode(e.target.value)}
                  disabled
                  inputProps={{
                    style: {
                      padding: "10px 12px",
                    },
                  }}
                />
                {/* {!isEdit && errors?.batchNoError && ( */}
              </Grid>

              <Grid item xs={12} sm={4}>
                <Typography variant="h6" gutterBottom>
                  Name
                </Typography>
                <Field
                  as={TextField}
                  fullWidth
                  variant="outlined"
                  name="name"
                  placeholder="Enter Name"
                  value={medicineName}
                  // onChange={handleInputChange1}
                  disabled
                  inputProps={{
                    style: {
                      padding: "10px 12px",
                    },
                  }}
                />

                <ErrorMessage name="name" component="div" />
              </Grid>

              <Grid item xs={12} sm={4}>
                <Typography variant="h6" gutterBottom>
                  Medicine Formula
                </Typography>
                <div style={{ position: "relative", zIndex: 10 }}>
                  <Dropdown
                    data={filtered_list}
                    handleChange={handleChangeEdit}
                    isOpen={isOpen}
                    setIsOpen={setIsOpen}
                    value={medicineFormulaName}
                    medicine_value={(data: any) => {
                      setFormulaId(data?.id);
                      setIsOpen(false);
                    }}
                    is_formula_drop={true}
                  />
                </div>
                {/* <ErrorMessage name="medicine_id" component="div" /> */}
              </Grid>

              <Grid item xs={12} sm={4}>
                <Typography variant="h6" gutterBottom>
                  Category
                </Typography>
                <Autocomplete
                  value={categoryName}
                  onChange={(event, value) => {
                    if (value) {
                      const selectedCategory = categoryData?.find(
                        (category: any) => category?.name === value
                      );
                      setCategoryId(selectedCategory?.id);
                      setCategoryName(selectedCategory?.name);
                    }
                  }}
                  id="combo-box-demo"
                  options={
                    categoryData?.map((category: any) => category?.name) || []
                  }
                  sx={{ width: "100%" }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select Category"
                      sx={{
                        "& .MuiInputBase-input": {
                          padding: "1px 5px !important",
                        },
                      }}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <Typography variant="h6" gutterBottom>
                  Dose
                </Typography>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={4}>
                    {/* Use TextField for digits */}
                    <TextField
                      fullWidth
                      variant="outlined"
                      name="doseDigits"
                      placeholder="Enter Dose"
                      value={doseDigits}
                      onChange={handleTextFieldChange}
                      inputProps={{
                        style: {
                          padding: "10px 12px",
                        },
                      }}
                    />
                    {/* Render error message if any */}
                    {/* <div
                    style={{ color: "red", fontSize: "14px", marginTop: "5px" }}
                  >
                    <ErrorMessage name="doseDigits" component="div" />
                  </div> */}
                  </Grid>
                  <Grid item xs={8}>
                    {/* Use Select for units */}
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      options={
                        Array.isArray(units)
                          ? units?.map((unit: any) => unit?.name)
                          : []
                      }
                      filterOptions={filterOptions}
                      onChange={handleSelectChange}
                      value={doseWord}
                      renderInput={(params) => (
                        <TextField {...params} placeholder="Select Unit" sx={{
                          "& .MuiInputBase-input": {
                            padding: "1px 5px !important",
                          },
                        }} />
                      )}
                    />
                    <div
                      style={{
                        color: "red",
                        fontSize: "14px",
                        marginTop: "5px",
                      }}
                    >
                      {/* Render error message for the select field if needed */}
                      {/* <ErrorMessage name="doseWord" component="div" /> */}
                    </div>
                  </Grid>
                </Grid>
                {doseError && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "14px",
                      marginTop: "5px",
                    }}
                  >
                    {doseError}
                  </div>
                )}
              </Grid>

              <Grid item xs={12} sm={4}>
                <Typography variant="h6" gutterBottom>
                  Generic Name
                </Typography>
                <Field
                  as={TextField}
                  fullWidth
                  variant="outlined"
                  name="generic_name"
                  placeholder="Enter Generic Name"
                  value={genericName}
                  onChange={handleInputChange}
                  inputProps={{
                    style: {
                      padding: "10px 12px",
                    },
                  }}
                />
                {/* <ErrorMessage name="generic_name" component="div" /> */}
              </Grid>

              <Grid item xs={12} sm={4}>
                <Typography variant="h6" gutterBottom>
                  Manufacturer Name
                </Typography>

                <Autocomplete
                  value={manufacturerName}
                  onChange={(event, value) => {
                    if (value) {
                      const selectedmanufacturer =
                        manufacturerNameData?.payload?.manufacturer?.find(
                          (manufacturer: any) => manufacturer?.name === value
                        );
                      setManufacturerId(selectedmanufacturer?.id);
                      setManufacturerName(selectedmanufacturer?.name);
                    }
                  }}
                  id="combo-box-demo"
                  options={
                    manufacturerNameData?.payload?.manufacturer?.map(
                      (manufacturer: any) => manufacturer?.name
                    ) || []
                  }
                  sx={{ width: "100%" }}
                  renderInput={(params) => (
                    <TextField {...params} placeholder="Select Manufacturer" sx={{
                      "& .MuiInputBase-input": {
                        padding: "1px 5px !important",
                      },
                    }} />
                  )}
                />
                {/* <ErrorMessage name="supplier_id" component="div" /> */}
              </Grid>
            </Grid>
          </Box>
          <Box sx={{ mt: 1.5 }}>
            <AppButton
              variant="contained"
              color="primary"
              type="button"
              onClick={handleSubmit}
              title="Update"
              sx={{ float: "right" }}
            />
          </Box>
        </Form>
      </Formik>
    </>
  );
};

export default EditMedicineModal;
